module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Transformation for Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("Romans 12:1–2: The Need for Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("Biblical Economic Formation: Behavior and Reasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Biblical Formation in Missional Perspective")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s1"
    }
  }, [_vm._v("Mission, Divine Purposiveness, and the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s2"
    }
  }, [_vm._v("Introduction to Missional Hermeneutics")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s3"
    }
  }, [_vm._v("Missional Hermeneutics in the Present Study")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s4"
    }
  }, [_vm._v("Asking Missionally Located Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s5"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Jesus’s Mission and Divine Blessing")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’s Mission Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beatitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Exodus: The God of Liberation Provides a Way Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Location and the Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contrasting Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Economic Formation in the Decalogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God and People in Covenantal Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Law, Understood Positively")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Choose Life!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to the Ten Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Decalogue (Exodus 20:1–17; Deuteronomy 5:6–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Economic Formation in the Covenantal Legal Codes")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Socioeconomic Realities in Ancient Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israelite Laws Protecting Widows, Orphans, and Resident Aliens")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gleaning Laws: Food for the Poor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laws concerning Collateral and Loans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sabbatical Year and Debt Remission")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jubilee")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Reflections: Justice from the Bottom Up")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Prophetic Formation for Economic Reasoning")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amos")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 1")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micah 6")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Creation and Its Discontents")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Genre and Genesis 1–3")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stories of Creation: The Biblical and the Babylonian")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Biblical Creation Story")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abundance, Adam and Eve, and Us")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Kingdom’s Economy of Abundance")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“What Must I Do to Inherit Eternal Life?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camels and the Eyes of Needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kingdom Abundance")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Formation for Economic Reasoning in Matthew")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch10s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sermon on the Mount: Renewing the Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch10s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 25:31–46: The Sheep and the Goats")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch10s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Reflections on Material from Matthew’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch10s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Kingdom Reversals and Economic Reasoning in Luke")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parable of the Two Lost Sons and Their Father")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Response to Grumbling by the Pharisees and Scribes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rich Man and Lazarus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zacchaeus, the Tax Collector")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch11s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Economic Reasoning and Faith in the Context of Divine Abundance")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch12s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“All Things in Common”: Unity and Covenantal Abundance in Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch12s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pauline Collection and the Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch12s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith and Works")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch12s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Missional Reasoning in Light of James 2")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch12s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Missional Hermeneutics, Transformed Reasoning, and Choosing Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch13s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Covenantal Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch13s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human Dignity")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch13s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liberation for the Oppressed")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch13s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living into the Abundance of the Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliographic Citations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names and Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0